import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import {useState} from 'react';
import {colorPalette} from '@jobseeker/lotus/foundations/colors';

import type {Props} from '../types';
import {Typography} from '@mui/material';
import {Box} from '@jobseeker/lotus/foundations/Layouts/Box';

const Default = (props: Props) => {
  const {
    title,
    open,
    anchorEl,
    handleMenuClose,
    theme,
    children,
    count,
    bannerHeight = 0,
    isForMapper = false,
    popperSx = {},
  } = props || {};

  const [arrowRef, setArrowRef] = useState(null);
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      id="drop-list-grow"
      placement="bottom-start"
      onMouseLeave={handleMenuClose}
      modifiers={[
        {
          name: 'arrow',
          enabled: true,
          options: {
            element: arrowRef,
          },
        },
      ]}
      sx={{
        zIndex: 1200,
        paddingTop: theme.spacing(3),
        paddingRight: {
          sm: theme.spacing(2),
          lg: theme.spacing(3),
        },
        inset: 'auto !important',
        position: 'fixed !important',
        transform: 'none !important',
        maxWidth: 'max-content',
        top: `${49 + bannerHeight}px !important`,
        float: 'right !important',
        right: '0px !important',
        ...popperSx,
      }}
      transition
    >
      {({TransitionProps}) => (
        <Fade {...TransitionProps} timeout={500}>
          {/* <StyledArrowSpan ref={setArrowRef} /> */}
          <Paper
            sx={{
              width: theme.spacing(title ? 55 : 30),
              backgroundColor: colorPalette.white.A50,
              boxShadow: '0px 6.480000019073486px 6px rgba(41, 41, 41, 0.06)',
              borderRadius: theme.spacing(isForMapper ? 1 : 2),
              border: '1px rgba(126, 126, 126, 0.20) solid',
            }}
          >
            {title && (
              <Box
                display={{md: 'flex'}}
                pt={theme.spacing(2)}
                justifyContent={isForMapper ? 'center' : 'normal'}
                sx={
                  isForMapper
                    ? {
                        borderBottom: isForMapper
                          ? `1px solid ${theme.palette.primary.main}`
                          : 'none',
                        height: 56,
                      }
                    : {
                        mr: theme.spacing(1.5),
                        ml: theme.spacing(3),
                      }
                }
              >
                <Typography
                  fontSize={theme.typography.pxToRem(isForMapper ? 16 : 14)}
                  fontWeight={
                    isForMapper
                      ? theme.typography.fontWeightBold
                      : theme.typography.fontWeightMedium
                  }
                  color={isForMapper ? 'primary' : 'secondary.main'}
                >
                  {title}
                </Typography>
                {count > 0 && (
                  <Box
                    borderRadius={theme.spacing(1.5)}
                    py={theme.spacing(0.5)}
                    px={theme.spacing(1)}
                    ml={theme.spacing(0.5)}
                    sx={{
                      backgroundColor: 'rgba(145, 184, 121, 0.16)',
                    }}
                  >
                    <Typography
                      fontSize={theme.typography.pxToRem(10)}
                      fontWeight={theme.typography.fontWeightMedium}
                      color={'primary.main'}
                    >{`${count} New`}</Typography>
                  </Box>
                )}
              </Box>
            )}
            {children}
          </Paper>
        </Fade>
      )}
    </Popper>
  );
};

export default Default;
